<!--suppress CheckEmptyScriptTag -->
<template>
  <form @submit.prevent="submit">

    <div
      v-if="model.user">
      <br>
      <h6>
        Username:
        <router-link :to="`/users/${model.user.id}`">
          {{ model.user.name }}
        </router-link>
      </h6>
      <h6>
        Email:
        <router-link :to="`/users/${model.user.id}`">
          {{ model.user.email }}
        </router-link>
      </h6>
      <br>
    </div>

    <fields
      :fields="fields.all()"
      :model="model"
      :errors="errors"
      layout="vertical"/>

    <div class="row">
      <div class="col-md-12">
        <h4>Attachments</h4>
        <p v-for="attachment in attachments">
          <a
            :href="attachment.path"
            target="_blank">{{ attachment.fileName }}</a>
        </p>
      </div>
    </div>

    <div class="form-group">
      <b-button
        type="submit"
        variant="primary">
        Save
      </b-button>

      <b-button
        type="button"
        variant="success"
        class="ml-3"
        @click="acceptPriceRequest">
        Accept
      </b-button>

      <b-button
        type="button"
        variant="danger"
        class="ml-3"
        @click="rejectPriceRequest">
        Reject
      </b-button>

      <b-button
        type="button"
        variant="light"
        class="ml-3"
        @click="cancel">
        Cancel
      </b-button>
    </div>
  </form>
</template>

<script>
import ResourceFormMixin from '../mixins/ResourceFormMixin';
import Proxy from './Proxy';

export default {
  name: 'PriceRequestsForm',

  mixins: [ResourceFormMixin],

  computed: {
    attachments() {

      let files = this.model.files

      if (typeof files === "undefined" || files === null) {
        return 'There are no attachments';
      }

      let origin = window.location.origin,
        attachments = JSON.parse(decodeURIComponent(files)),
        _return = []

      for (var attachment in attachments) {
        _return.push({
          fileName: attachments[attachment].fileName,
          path: origin + attachments[attachment].path,
        })
      }

      return _return;
    }
  },

  created() {
    this.loadForm(Proxy);
  },

  methods: {
    submit() {
      this.save(Proxy)
        .then(() => {
          this.$toast.success('Price request was saved successfully');
        });
    },

    async acceptPriceRequest() {

      const accept = await this.$alert.warning('Please confirm your action', '', {
        showCancelButton: true,
        confirmButtonText: 'Confirm'
      });

      try {
        if (accept.value) {
          this.$http.put(`/price-requests/${this.model.id}`, {
            accept: true,
            ...JSON.parse(this.model.filter_query)
          }).then(() => {
            this.$toast.success('Price request accepted');
            this.$router.back();
          }).catch(err => {
            this.$toast.error(err.response.message);
          })
        }
      } catch (e) {
        if(!this.model || typeof this.model.filter_query !== "object"){
          console.log(e)
          return
        }
        if (accept.value) {
          this.$http.put(`/price-requests/${this.model.id}`, {
            accept: true,
            ...this.model.filter_query
          }).then(() => {
            this.$toast.success('Price request accepted');
            this.$router.back();
          }).catch(err => {
            this.$toast.error(err.response.message);
          })
        }
      }
    },

    async rejectPriceRequest() {

      const reason = await this.$alert.question('Why you reject this price request?', '', {
        input: 'textarea',
        showCancelButton: true
      });

      if (reason.value) {
        this.$http.delete(`/price-requests/${this.model.id}`, {
          data: {
            rejected: true,
            message: reason.value,
          }
        }).then(() => {
          this.$toast.success('Successfully rejected');
          this.$router.back();
        }).catch(err => {
          this.$toast.error('An error occurred when rejecting price request');
          console.log(err.response);
        });
      } else {
        if (!reason.hasOwnProperty('dismiss'))
          this.$alert.error(`Reason text can't be empty`);
      }
    },
  },

};
</script>
<style>
textarea#message_text {
  min-height: 200px;
}
</style>
